import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface H2Props extends HTMLAttributes<HTMLHeadingElement> {}

const H2 = forwardRef<HTMLHeadingElement, H2Props>(
  ({ className, children, ...props }, ref) => {
    return (
      <h2
        ref={ref}
        className={cn(
          'scroll-m-20 text-3xl font-semibold tracking-tight first:mt-0',
          className
        )}
        {...props}
      >
        {children}
      </h2>
    );
  }
);

H2.displayName = 'H2';

export { H2 };
